import { navigate as externalNavigate } from "vike/client/router"

export function navigate(url, options) {
  //the options are _blank, _self, _parent, _top
  if (url.startsWith("http")) return window.open(url, options)
  return externalNavigate(url, options)
}
